import { isFirebaseConfigured, auth } from "./firebase";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

const ADMIN_EMAIL = (
  process.env.REACT_APP_ADMIN_EMAIL || ""
).trim().toLowerCase();

const FRIENDLY = {
  "auth/invalid-credential": "Invalid email or password.",
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/user-not-found": "No admin account found for this email.",
  "auth/wrong-password": "Invalid email or password.",
  "auth/too-many-requests": "Too many attempts. Please try again later.",
};

export const friendlyAuthError = (e) =>
  FRIENDLY[e?.code] || e?.message || "Login failed. Please try again.";

export async function login(email, password) {
  const em = (email || "").trim().toLowerCase();

  if (!isFirebaseConfigured || !auth) {
    const err = new Error(
      "Firebase Authentication is not configured. Admin login is unavailable."
    );
    err.code = "auth/not-configured";
    throw err;
  }

  const cred = await signInWithEmailAndPassword(auth, em, password);

  return {
    email: cred.user.email,
    uid: cred.user.uid,
  };
}

export async function logout() {
  if (auth) {
    await signOut(auth);
  }
}

export function subscribeAuth(cb) {
  if (!isFirebaseConfigured || !auth) {
    cb(null);
    return () => {};
  }

  return onAuthStateChanged(auth, (user) => {
    cb(
      user
        ? {
            email: user.email,
            uid: user.uid,
          }
        : null
    );
  });
}

export function isAdmin(user) {
  if (!user || !ADMIN_EMAIL) return false;

  return (user.email || "").trim().toLowerCase() === ADMIN_EMAIL;
}